import { useMemo } from 'react';
import { sumOrderItems } from '@/utilities/calculateItemMetrics';

const normalizeRange = (metric) => {
    if (!metric) return 0;
    return Array.isArray(metric) ? Math.max(...metric.map((weight) => parseFloat(weight))) : parseFloat(metric);
};

// These fields can hold a range rather than a plain number, so every read goes through
// normalizeRange, and each falls back to the per-unit field when the computed total is absent.
const itemWeight = (item) => normalizeRange(item.total_weight) || normalizeRange(item.weight);
const itemCubes = (item) => normalizeRange(item.total_cubes) || normalizeRange(item.cubes_per_unit);

export const useTotalWeight = (orders) => {
    return useMemo(() => sumOrderItems(orders, { value: itemWeight }), [orders]);
};

export const useTotalCubes = (orders) => {
    return useMemo(() => sumOrderItems(orders, { value: itemCubes }), [orders]);
};
